import 'magnific-popup';

jQuery(document).ready(function($){
    /**
     * 添加相册弹出效果
     */
    var popup = $('.js-popup');

    if (popup) {
        popup.each(function() {

            var items = [];

            $(this).find('.js-gallery').each(function() {
                var item = {};
                item.src = $(this).attr('href');
                item.title = $(this).attr('title');
                items.push(item);
            });

            $(this).find('.js-gallery').magnificPopup({
                items  : items,
                type   : 'image',
                gallery: {
                    enabled           : true,
                    navigateByImgClick: true,
                },
            });
        });
    }
});
